import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from "@angular/forms";
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { Catalogo, General } from "../../interfaces/general";
import {personaVivienda} from "../../interfaces/solicitudes";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: "app-personas-vivienda",
	templateUrl: "./personas-vivienda.component.html",
	styleUrls: ["./personas-vivienda.component.css"],
})
export class PersonasViviendaComponent implements OnInit {

	@Input() catalogos: General;
	tieneCURP = false;
	estados: any;
	municipios: any;
	idEstado;
	extranjeroEs = false;
	pais: string;
	paises: any;
	@Input() estadosCiviles: Array<Catalogo>;
	@Input() PersonasVivienda: FormGroup
	@Input() esEdicion: boolean = true
	CURP
	@Input() listaDeCurps: []
	@Input() PersonasViviendaData;
	@Output() conCurp = new EventEmitter()

	displayedColumns: string[] = ["Concepto", "Monto", "Observaciones"];
	personasColumns: string[] = [
		"No.",
		"Nombre",
		"Parentesco",
		"Edad",
		"Ocupación",
		"Monto ingreso fijo",
		"Monto ingreso variable",
		"Origen ingreso",
		"Monto que aporta",
		"Remover",
	];

	constructor(
		private formBuilder: FormBuilder,
		private serviciosGenerales: ServiciosGeneralesService,
		private snackBar: MatSnackBar
	) {
	}

	ngOnInit(): void {
		console.log('init')


		this.crearEgresosMensuales();
		this.crearEgresosFamiliares();
		this.resetTable();
	}

	ngOnChanges(changes):void {

	}

	agregarPersonaVivienda(): void {
		console.log(this.CURP)
		const CURP = this.CURP;
		console.log(this.PersonasVivienda.controls.ListaPersonasVivienda.value)
		if (CURP.length === 18 &&
			this.PersonasVivienda.controls.ListaPersonasVivienda.value.filter(value => value.Personas_CURP === CURP).length === 0 ) {
			this.obtenerdatosCURP(CURP);
			this.CURP = ""
		}else {
			this.openSnackBar('Esta CURP ya fue registrada en la lista de personas vivienda','Entendido');
		}
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
		duration: 2000,
		});
	}

	get Referencias(): FormArray {
		return this.PersonasVivienda.get('ListaPersonasVivienda') as FormArray
	}

	get egresoMensual() {
		return this.PersonasVivienda.get('ListaEgresoMensuales') as FormArray
	}
	get egresoFamiliar() {
		return this.PersonasVivienda.get('ListaEgresoFamiliares') as FormArray
	}


	listaEgresoMensuales (id, EgresoMonto) {
		let group = this.formBuilder.group({
			ConceptoID: [id , ''],
			EgresoMonto: [EgresoMonto , ''],
			Observaciones: ['' , ''],
		})

		return group
	}

	listaEgresoFamiliares (id, EgresoMonto) {
		let group = this.formBuilder.group({
			ConceptoID: [id , ''],
			EgresoMonto: [EgresoMonto , ''],
			Observaciones: ['' , ''],
		})

		return group
	}

	listaPersonaVivienda (persona): FormGroup {

		const datos = persona.BirthDate.split('/')
		const ano = datos[2]
		const mes = datos[1]
		const dia = datos[0]
		const nuevaFecha = `${ano}-${mes}-${dia}T00:00:00`
		const fechaCumpleanos = this.calculateAge(new Date(+ano,+mes,+dia))

		let personaVivienda =  this.formBuilder.group({
			PersonaVivienda_IngresoMonto: ['' , ''],
			PersonaVivienda_Ingreso_Tipo_ID: ['' , ''],
			PersonaVivienda_OtroIngresoMonto: ['' , ''],
			PersonaVivienda_OtroIngreso_Origen: ['' , ''],
			PersonaVivienda_Otros_Ingre_Tipo: ['' , ''],
			PersonaVivienda_MontoAportacion: ['' , ''],

			Persona_OcupacionID: [1001, ''],
			Persona_OficioID: [1001, ''],
			Personas_ApellidoMaterno: [persona.Surname , ''],
			Personas_ApellidoPaterno: [persona.Lastname , ''],
			Personas_CURP: [persona.Curp , ''],
			Edad: [fechaCumpleanos , ''],
			Personas_FechaNacimiento: [nuevaFecha,''],
			Personas_Genero: [persona.Genre , ''],
			Personas_Nombre: [persona.Name , ''],
			SolicitantePersona_ParentescoID: ['' , ''],

		})

		return personaVivienda;
	}


	calculateAge(birthday) {
		const ageDifMs = Date.now() - birthday.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}
	agregarReferencia(persona) {
		this.Referencias.push(this.listaPersonaVivienda(persona));
		this.conCurp.emit()
	}
	crearEgresosMensuales() {
		this.catalogos.Conceptos_Egreso_Solicitante.forEach((egreso, index) => {
			const estaEnLista:Array<any> = this.PersonasViviendaData.ListaEgresoMensuales.filter(
				item =>  item.ConceptoID === egreso.ID)
			this.egresoMensual.push(this.listaEgresoFamiliares(
				egreso.ID, estaEnLista.length > 0 ? estaEnLista[0].EgresoMonto: 0))
		});
		if(!this.esEdicion) {
			this.egresoMensual.disable()
		}
	}
	crearEgresosMensualesReset(PersonasViviendaData) {
		this.egresoMensual.clear();
		this.catalogos.Conceptos_Egreso_Solicitante.forEach((egreso, index) => {

			const estaEnLista:Array<any> = PersonasViviendaData.ListaEgresoMensuales.filter(
				item => item.ConceptoID === egreso.ID)
			this.egresoMensual.push(this.listaEgresoFamiliares(
					egreso.ID, estaEnLista.length > 0 ? estaEnLista[0].EgresoMonto: 0))
		});
		if(!this.esEdicion) {
			this.egresoMensual.disable()
		}
	}
	crearEgresosFamiliares() {
		this.catalogos.Conceptos_Egreso_Familiares.forEach((egreso, index) => {


			const estaEnLista:Array<any> = this.PersonasViviendaData.ListaEgresoFamiliares.filter(
					item => item.ConceptoID === egreso.ID)
			this.egresoFamiliar.push(this.listaEgresoFamiliares(
					egreso.ID, estaEnLista.length > 0 ? estaEnLista[0].EgresoMonto: 0))

		});
		if(!this.esEdicion) {
			this.egresoFamiliar.disable()
		}
	}
	crearEgresosFamiliaresReset(PersonasViviendaData) {
		this.egresoFamiliar.clear();
		this.catalogos.Conceptos_Egreso_Solicitante.forEach((egreso, index) => {
			const estaEnLista:Array<any> = PersonasViviendaData.ListaEgresoFamiliares.filter(
				item => item.ConceptoID === egreso.ID)
		this.egresoFamiliar.push(this.listaEgresoFamiliares(
				egreso.ID, estaEnLista.length > 0 ? estaEnLista[0].EgresoMonto: 0))
		});
		if(!this.esEdicion) {
			this.egresoFamiliar.disable()
		}
	}
	quitarPersonaVivienda(index) {
		this.Referencias.removeAt(index)
	}
	obtenerdatosCURP(CURP: string) {
		this.tieneCURP = false;
		this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {
			this.tieneCURP = res.Ok;
			if (res.Ok) {
				if (res.Data.Country === "MEX") {
					this.extranjeroEs = false;
				} else {
					this.pais = res.Data.Country;
					this.extranjeroEs = true;
					this.obtenerPaises();
				}
				this.agregarReferencia(res.Data)
			} else {
				console.log("Snackbar");
			}
		});
	}


	obtenerPaises(): void {
		// this.serviciosGenerales.listadoPaises().subscribe(res => {
		//   this.paises = res;
		//   const pais = this.paises.filter(pais => pais.ISO_A3 === this.pais)
		//   console.log(pais);
		//   this.personaFormulario.get('pais').setValue(pais.ID);
		// });
	}

	resetTable(){
		this.PersonasViviendaData.valueChanges.subscribe((res)=>{
			console.log('FUNCUIONA')
		})
	}



}
